import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Header = () => {
  const location = useLocation();

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Person",
              "name": "Bungen Lee",
              "description": "Fantasy and Science Fiction Author",
              "url": "https://yourusername.github.io/bungen-lee-website",
              "sameAs": []
            }
          `}
        </script>
      </Helmet>
      
      <header className="header">
        <div className="container">
          <nav className="nav">
            <Link to="/" className="logo">
              <i className="fas fa-pen-nib"></i>
              <span>Bungen Lee</span>
            </Link>
            
            
          </nav>
        </div>
      </header>

      <style jsx>{`
        .header {
          background: rgba(10, 10, 10, 0.95);
          backdrop-filter: blur(10px);
          border-bottom: 1px solid var(--color-border);
          position: sticky;
          top: 0;
          z-index: 1000;
        }
        
        .nav {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem 0;
        }
        
        .logo {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          font-size: 1.5rem;
          font-weight: 700;
          text-decoration: none;
          background: var(--gradient-text);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        
        .nav-links {
          display: flex;
          gap: 2rem;
        }
        
        .nav-link {
          color: var(--color-text-secondary);
          text-decoration: none;
          font-weight: 500;
          transition: all 0.3s ease;
          position: relative;
        }
        
        .nav-link:hover,
        .nav-link.active {
          color: var(--color-accent);
        }
        
        .nav-link.active::after {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 0;
          right: 0;
          height: 2px;
          background: var(--gradient-gold);
        }
        
        @media (max-width: 768px) {
          .nav {
            flex-direction: column;
            gap: 1rem;
          }
          
          .nav-links {
            gap: 1.5rem;
          }
        }
      `}</style>
    </>
  );
};

export default Header;